export default "__VITE_ASSET__K3Szjs1a__"